var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4661)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_4661)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79013 4.8502C2.875 6.10976 2.875 7.90651 2.875 11.5C2.875 15.0935 2.875 16.8902 3.79013 18.1498C4.08567 18.5566 4.44341 18.9143 4.8502 19.2099C6.10976 20.125 7.90651 20.125 11.5 20.125C15.0935 20.125 16.8902 20.125 18.1498 19.2099C18.5566 18.9143 18.9143 18.5566 19.2099 18.1498C20.125 16.8902 20.125 15.0935 20.125 11.5C20.125 7.90651 20.125 6.10976 19.2099 4.8502C18.9143 4.44341 18.5566 4.08567 18.1498 3.79013C16.8902 2.875 15.0935 2.875 11.5 2.875C7.90651 2.875 6.10976 2.875 4.8502 3.79013C4.44341 4.08567 4.08567 4.44341 3.79013 4.8502Z",
    fill: "#CEEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79013 4.8502C2.875 6.10976 2.875 7.90651 2.875 11.5C2.875 15.0935 2.875 16.8902 3.79013 18.1498C4.08567 18.5566 4.44341 18.9143 4.8502 19.2099C6.10976 20.125 7.90651 20.125 11.5 20.125C15.0935 20.125 16.8902 20.125 18.1498 19.2099C18.5566 18.9143 18.9143 18.5566 19.2099 18.1498C20.125 16.8902 20.125 15.0935 20.125 11.5C20.125 7.90651 20.125 6.10976 19.2099 4.8502C18.9143 4.44341 18.5566 4.08567 18.1498 3.79013C16.8902 2.875 15.0935 2.875 11.5 2.875C7.90651 2.875 6.10976 2.875 4.8502 3.79013C4.44341 4.08567 4.08567 4.44341 3.79013 4.8502Z",
    stroke: "url(#paint0_linear_1_4661)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_4661)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8022 10.0893C17.0816 9.80735 17.0796 9.35227 16.7976 9.07283C16.5157 8.7934 16.0606 8.79543 15.7812 9.07737L14.1067 10.7669C13.4271 11.4526 12.9594 11.9229 12.5631 12.2412C12.1781 12.5503 11.9309 12.6564 11.7094 12.6846C11.5704 12.7023 11.4297 12.7023 11.2906 12.6846C11.0692 12.6564 10.8219 12.5503 10.4369 12.2412C10.0406 11.9229 9.57293 11.4526 8.89334 10.7669L7.21883 9.07737C6.9394 8.79543 6.48431 8.7934 6.20238 9.07283C5.92044 9.35227 5.91841 9.80735 6.19784 10.0893L7.90251 11.8092C8.54453 12.457 9.06928 12.9865 9.53682 13.362C10.023 13.7524 10.5165 14.0351 11.1088 14.1106C11.3686 14.1437 11.6314 14.1437 11.8912 14.1106C12.4835 14.0351 12.977 13.7524 13.4632 13.362C13.9307 12.9865 14.4555 12.4571 15.0975 11.8092L16.8022 10.0893Z",
    fill: "url(#paint1_linear_1_4661)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_4661",
    x: -21.625,
    y: -21.625,
    width: 66.25,
    height: 66.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_4661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_4661",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_4661",
    x: 2.98959,
    y: 5.86458,
    width: 27.0208,
    height: 21.2708,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4661",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4661",
    x1: 2.875,
    y1: 2.875,
    x2: 20.1337,
    y2: 20.1163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4661",
    x1: 11.5928,
    y1: 15.2583,
    x2: 17.3276,
    y2: 3.50425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownSquare);
export default __webpack_public_path__ + "static/media/down-square.b06a71098204d03d6e29d540e6112774.svg";
export { ForwardRef as ReactComponent };